import {region} from '../../../shared/regions.mjs';
import services from '../../../data/world-services.json';

export type TownServiceId =
  | 'trainer'
  | 'quest'
  | 'skill-reset'
  | 'stat-reset'
  | 'class-change'
  | 'merchant'
  | 'pet-vendor'
  | 'ghost-show'
  | 'ghost-market'
  | 'border-guide';

export type TownService = {
  id: TownServiceId;
  nameTh: string;
  x: number;
  cost?: number;
};

export const WORLD_SERVICES = services as {
  townId: string;
  interactionRange: number;
  services: TownService[];
  templeMonk: { x:number; interactionRange:number; durationMs:number; defense:number };
  capture: { itemId:string; range:number; hpRatio:number; rewardBie:number };
};

export const TOWN_SERVICE_BY_ID = new Map(WORLD_SERVICES.services.map(service=>[service.id,service] as const));

export function townService(id:TownServiceId):TownService {
  const value=TOWN_SERVICE_BY_ID.get(id);
  if(!value)throw new Error('Unknown town service: '+id);
  return value;
}

export function nearTownService(mapId:string|undefined,x:number|undefined,id:TownServiceId):boolean {
  if((mapId!==WORLD_SERVICES.townId&&region(mapId??'')?.services!=='town')||x===undefined)return false;
  return Math.abs(x-townService(id).x)<=WORLD_SERVICES.interactionRange;
}

export function nearTempleMonk(mapId:string|undefined,x:number|undefined):boolean {
  if(!mapId?.startsWith('wat-')||x===undefined)return false;
  return Math.abs(x-WORLD_SERVICES.templeMonk.x)<=WORLD_SERVICES.templeMonk.interactionRange;
}
